import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Index from './container/index';
import 'antd/dist/antd.css';
import './customized.css';

ReactDOM.render(<Index />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
